<app-breadcrumb [title]="'Round-I'"></app-breadcrumb>


<app-loader [show]="skeleton"></app-loader>
<div [class.d-none]="skeleton">


    <div class="row">
        <div class="col-12">
            <div class="border rounded p-3 mb-3">

                <div *ngIf="employeeMerit && employeeMerit.school">
                    <dl class="row">
                        <dt class="col-sm-4">Transfer Category</dt>
                        <dd class="col-sm-8">
                            {{ employeeMerit.transferCategory?.name }}
                        </dd>

                        <dt class="col-sm-4">Alloted School/Place</dt>
                        <dd class="col-sm-8">
                            {{ employeeMerit.school?.name + ' (' + employeeMerit.school?.state?.name + ')' }}
                        </dd>
                        <dt class="col-sm-4">Type</dt>
                        <dd class="col-sm-8">
                            {{ employeeMerit.vacantPost?.vacancyType?.name }}
                        </dd>
                    </dl>
                </div>
                <div *ngIf="!employeeMerit.school" class="text-center">
                    <h4 class="description text-default">You have not getting transfer to any place/school.</h4>
                </div>
                <div *ngIf="!employeeMerit.school && !employeeMerit.isTransfer" class="text-center">
                    <h4 class="description text-default">You have not getting transfer to any place/school or You have not participate in Transfer Drive.</h4>
                </div>

                <div *ngIf="employeeMerit" class="d-flex justify-content-end">
                    <button *ngIf="isAllowedSecondRound"
                        type="button" [routerLink]="['/employee/transfer-request']"
                        class="btn btn-danger rounded-0">Apply in Round-II</button>
                </div>
            </div>
        </div>
    </div>

</div>